module.exports = __webpack_public_path__ + "img/blog_color_julio_palette.87f92b0e.png";